module.exports = __webpack_public_path__ + "static/slack-beb2da69238f4a5bad5bd1a599bcc8a6.svg";